// removed by extract-text-webpack-plugin
module.exports = {"button":"Button__button___2a549","medium":"Button__medium___1zd7r","small":"Button__small___1ilkx","large":"Button__large___1M1_R","secondary":"Button__secondary___22F7i","margin-left":"Button__margin-left___2d-rC","margin-right":"Button__margin-right___PMPz8","loading":"Button__loading___15BEO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.css
// module id = 696
// module chunks = 0